import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { hexToHsl } from "@/lib/format";

const BrandCtx = createContext(null);

function setFavicon(href) {
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = href;
}

export function BrandingProvider({ children }) {
  const [config, setConfig] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/public/config");
      setConfig(data);
    } catch {
      setConfig((c) => c || { branding: { website_name: "", tagline: "" }, privacy: {}, setup_required: false, error: true });
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    if (!config?.branding) return;
    const b = config.branding;
    const root = document.documentElement.style;
    const p = hexToHsl(b.primary_color);
    const s = hexToHsl(b.secondary_color);
    if (p) { root.setProperty("--primary", p); root.setProperty("--ring", p); }
    if (s) root.setProperty("--brand-secondary", s);
    if (b.website_name) document.title = `${b.website_name} — ${b.tagline || ""}`.replace(/ — $/, "");
    if (b.favicon_url || b.app_icon_url) setFavicon(fileUrl(b.favicon_url || b.app_icon_url));
  }, [config]);

  return <BrandCtx.Provider value={{ config, branding: config?.branding || {}, privacy: config?.privacy || {}, reload: load }}>{children}</BrandCtx.Provider>;
}

export const useBranding = () => useContext(BrandCtx);
